export default __webpack_public_path__ + "static/media/Img3.bc8b5e4b.jpg";